export default __webpack_public_path__ + "static/media/25A.b8001930.JPG";